import { articles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            深度解析
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            专业影评人带你深入解读韩国电影背后的叙事艺术与社会思考
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              slug={article.slug}
              excerpt={article.excerpt}
              author={article.author}
              date={article.date}
              coverUrl={article.coverUrl}
              categorySlug={article.categorySlug}
            />
          ))}
        </div>
      </div>
    </section>
  );
}